import { render, staticRenderFns } from "./EditCourse.vue?vue&type=template&id=17c8b281&scoped=true"
import script from "./EditCourse.vue?vue&type=script&lang=ts"
export * from "./EditCourse.vue?vue&type=script&lang=ts"
import style0 from "./EditCourse.vue?vue&type=style&index=0&id=17c8b281&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c8b281",
  null
  
)

export default component.exports